import React, { useState } from "react";

const CustomStatuses = () => {
  const [selectedParent, setSelectedParent] = useState("In Progress");
  const [newStatusName, setNewStatusName] = useState("");

  const parentStatuses = [
    {
      name: "To Do",
      count: 3,
      children: [
        { name: "To Do", color: "blue" },
        { name: "Backlog", color: "purple" },
        { name: "Planned", color: "pink" },
      ],
    },
    {
      name: "In Progress",
      count: 3,
      children: [
        { name: "InProgress", color: "blue" },
        { name: "InProgress2", color: "purple" },
        { name: "Working On", color: "pink" },
      ],
    },
    {
      name: "Under Review",
      count: 3,
      children: [
        { name: "Review", color: "blue" },
        { name: "QA Testing", color: "purple" },
        { name: "Pending Approval", color: "pink" },
      ],
    },
    {
      name: "Closed",
      count: 3,
      children: [
        { name: "Completed", color: "blue" },
        { name: "Done", color: "purple" },
        { name: "Archived", color: "pink" },
      ],
    },
  ];

  const getColorClasses = (color) => {
    const base =
      "text-xs font-medium px-3 py-1.5 rounded-full border transition-all group inline-flex items-center gap-2";
    switch (color) {
      case "blue":
        return `${base} bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100`;
      case "purple":
        return `${base} bg-purple-50 text-purple-700 border-purple-200 hover:bg-purple-100`;
      case "pink":
        return `${base} bg-pink-50 text-pink-700 border-pink-200 hover:bg-pink-100`;
      default:
        return `${base} bg-gray-50 text-gray-700 border-gray-200 hover:bg-gray-100`;
    }
  };

  const handleCreateStatus = (e) => {
    e.preventDefault();
    if (!newStatusName.trim()) return;

    alert(`New status "${newStatusName}" created under "${selectedParent}"!`);
    // Here you would normally:
    // 1. Send to backend/API
    // 2. Update local state
    setNewStatusName("");
  };

  return (
    <section className="py-16 sm:py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left side - Status Groups */}
          <div className="space-y-8 lg:space-y-10">
            <div>
              <h2 className="custom-status-heading text-gray-900 leading-tight">
                Custom Status
                <br />
                {/* bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent */}
                <span className="text-[#093a5b]">Your Way</span>
              </h2>
              <p className="mt-5 custom-status-para text-gray-600">
                4 parent statuses with unlimited custom child statuses.
                <br />
                Create and organize workflows that match your team's process.
              </p>
            </div>

            <div className="grid sm:grid-cols-2 gap-6">
              {parentStatuses.map((status) => (
                <div
                  key={status.name}
                  className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-2xl p-5 sm:p-6 hover:shadow-lg transition-all duration-300 hover:scale-[1.02]"
                >
                  <div className="flex items-center justify-between mb-4">
                    <h4 className="text-lg font-semibold text-gray-900">
                      {status.name}
                    </h4>
                    <span className="text-xs text-gray-500 font-medium">
                      {status.count} custom statuses
                    </span>
                  </div>

                  <div className="flex flex-wrap gap-2">
                    {status.children.map((child) => (
                      <div
                        key={child.name}
                        className={`group ${getColorClasses(child.color)}`}
                      >
                        <span>{child.name}</span>
                        <button
                          className="opacity-0 group-hover:opacity-100 hover:scale-110 transition-all duration-200"
                          aria-label="Remove status"
                        >
                          <svg
                            className="w-3.5 h-3.5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right side - Create Form */}
          <div className="relative">
            <div className="bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 rounded-3xl p-6 sm:p-8 border border-blue-200/60 shadow-2xl">
              <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg">
                <div className="flex items-center justify-between mb-6">
                  <h4 className="Create-Custom-Status font-semibold text-gray-900">
                    Create Custom Status
                  </h4>
                  <button
                    aria-label="Close"
                    className="text-gray-400 hover:text-gray-600 transition-colors"
                  >
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                <form onSubmit={handleCreateStatus} className="space-y-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Parent Status
                    </label>
                    <select
                      value={selectedParent}
                      onChange={(e) => setSelectedParent(e.target.value)}
                      className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    >
                      {parentStatuses.map((s) => (
                        <option key={s.name} value={s.name}>
                          {s.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Status Name
                    </label>
                    <input
                      type="text"
                      value={newStatusName}
                      onChange={(e) => setNewStatusName(e.target.value)}
                      placeholder="e.g., Working On It"
                      className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    />
                  </div>

                  <button
                    type="submit"
                    // bg-gradient-to-r from-blue-600 to-purple-600 text-white font-medium rounded-xl shadow-lg hover:shadow-xl hover:from-blue-700 hover:to-purple-700
                    className="w-full py-3.5 px-6 bg-gradient-to-r from-[#062e48] to-[#093a5b] text-white font-medium rounded-xl shadow-lg hover:shadow-xl hover:from-[#093a5b] hover:to-[#0c4a6e]  transition-all duration-300 transform hover:scale-[1.02] "
                  >
                    Create Status
                  </button>
                </form>
              </div>

              <div className="mt-6 bg-white/60 backdrop-blur-sm rounded-2xl p-5 border border-white/80 text-center">
                <p className="text-sm text-gray-600 italic">
                  💡 Create statuses on-the-fly from the dropdown or manage them
                  here
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomStatuses;
